var ContentService = require('services/content-service');
var LocaleService = require('services/locale-service');
var Utils = require('lib/utils');
var SurveyService = require('services/survey-service');
var EvaluationService = require('services/evaluation-service');
var AssessmentService = require('services/assessment-service');

//TODO: do we need a base service class?
var PageService = {
  loadPage: function(moduleKey, activityKey, pageKey){
    //TODO: figure out when to 'unload' the current page
    var pagePresent = pageKey !== undefined && pageKey !== null && pageKey !== '';
    var activityPresent = activityKey !== undefined && activityKey !== null && activityKey !== '';

    if (!EF.module || moduleKey != EF.module.get('key')) {
      EF.setModuleByKey(moduleKey);
      LocaleService.setModuleResources(moduleKey);
    }

    if (!EF.module.currentActivity || activityKey != EF.module.currentActivity.get('key')){
      if (activityPresent){
        EF.module.setActivityByKey(activityKey);
      } else {
        EF.module.getStartingActivity();
      }
      if (!EF.module.currentActivity){
        EF.module.currentActivity = EF.module.activities.head();
      }
      if (EF.module.currentActivity.isComplete()) {
        EF.module.currentActivity.set('redo', true);
      }
    }

    if (!EF.module.currentActivity.currentPage || pageKey != EF.module.currentActivity.currentPage.get('key')) {
      if (pagePresent){
        EF.module.currentActivity.setPageByKey(pageKey);
      } else {
        EF.module.currentActivity.getStartingPage();
      }
      if (!EF.module.currentActivity.currentPage){
        EF.module.currentActivity.currentPage = EF.module.currentActivity.pages.head();
      }
      //TODO: check why progress was being set during page load
    }

    //TODO: should we use the content service here instead of in the page controller?
    return ContentService.applyPageContent(EF.module.currentActivity.currentPage);
  },
  getNextPage: function(){
    //TODO: this method uses the autoNextActivity option, do we need an autoNextModule option?
    //      specifically thinking about the NHL course which may have multiple modules in a 'group'
    return EF.module.getNextPageByKey(EF.module.currentActivity.currentPage.get('key'));
  },

  getPageByKey: function(key) {
    var activity = {};
    if(key.indexOf('/') > -1) {
      var split = key.split('/');
      var activityName = split[0];
      activity = EF.module.activities.find((acc) => {
        return acc.get('key') == activityName;
      });
      key = split[1];
    } else {
      activity = EF.module.currentActivity;
    }

    return activity.pages.find(function(page) {
      return page.get('key') === key;
    });
  },

  getPreviousPage: function(){
    return EF.module.getPreviousPageByKey(EF.module.currentActivity.currentPage.get('key'));
  },

  preventSkippingPages: function(page, params) {
    let localSkipping = EF.options.local ? EF.options.pageSkipping : false;
    if (params.page && !localSkipping && !EF.enrollment.get('demoMode') && !EF.module.isComplete()) {
      // prevent skipping incomplete pages
      let lastCompleted = EF.module.currentActivity.pages.lastCompleted();
      let key   = lastCompleted.get('key');
      let next  = EF.module.currentActivity.nextPageByKey(key);
      while (next && next.get('optional')) {
        next = EF.module.currentActivity.nextPageByKey(next.get('key'));
      }
      if (next && page.get('index') > next.get('index')) {
        Utils.redirectToPage(lastCompleted);
        return false;
      }
    }
    return true;
  },

  shouldBeSkipped: function(page) {
    var skipCallback = page.script.skip;
    var skipJSON = page.model.get('skip');

    var evaluationShouldBeSkipped = EvaluationService.shouldSkip();

    if(skipCallback) {
      return skipCallback(page);
    } else if(skipJSON) {
      if (skipJSON.customization){
        return EF.customizations.getByKeyAndSlug(skipJSON.customization, skipJSON.slug) === undefined;
      } else if (skipJSON.resource_type){
        return EF.resources.byTypeSync(skipJSON.resource_type, skipJSON.resource_sub_type).length === 0;
      } else if (skipJSON.survey_slug) {
        return SurveyService.userHasCompletedSurvey(skipJSON.survey_slug) || evaluationShouldBeSkipped;
      } else if (skipJSON.assessment_slug) {
        return AssessmentService.userHasCompletedAssessment(skipJSON.assessment_slug) || evaluationShouldBeSkipped;
      }
    }
  }
};

module.exports = PageService;
